module.exports = __webpack_public_path__ + "static/media/css icon.9b398275.svg";